import React from "react";
import {
  Paper,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  TableContainer
} from "@material-ui/core";
import { heatmapColor, textColor } from "../utils/heatmapColor";

export default function HeatmapTableColor({ days, hours, matrix }) {
  if (!days || !hours || !matrix) return null;

  const values = matrix.flat();
  const min = Math.min(...values);
  const max = Math.max(...values);

  return (
    <TableContainer
      component={Paper}
      style={{
        borderRadius: 14,
        overflowX: "auto",   // 🔥 CLAVE
        maxWidth: "100%"
      }}
    >
      <Table
        size="small"
        stickyHeader
        style={{
          minWidth: hours.length * 70 + 120 // 🔥 fuerza ancho real
        }}
      >
        <TableHead>
          <TableRow>
            <TableCell
              style={{
                fontWeight: 800,
                position: "sticky",
                left: 0,
                background: "#fff",
                zIndex: 2
              }}
            >
              Día
            </TableCell>

            {hours.map(h => (
              <TableCell
                key={h}
                align="center"
                style={{
                  fontWeight: 800,
                  minWidth: 70
                }}
              >
                {String(h).padStart(2, "0")}
              </TableCell>
            ))}
          </TableRow>
        </TableHead>

        <TableBody>
          {days.map((day, i) => (
            <TableRow key={day}>
              {/* Día fijo al hacer scroll */}
              <TableCell
                style={{
                  fontWeight: 700,
                  position: "sticky",
                  left: 0,
                  background: "#fff",
                  zIndex: 1
                }}
              >
                {day}
              </TableCell>

              {hours.map((h, j) => {
                const value = matrix[i][j];
                const bg = heatmapColor(value, min, max);

                return (
                  <TableCell
                    key={h}
                    align="center"
                    title={`Hora ${h}:00 → ${value} pedidos`}
                    style={{
                      backgroundColor: bg,
                      color: textColor(bg),
                      fontWeight: 700,
                      minWidth: 70,
                      whiteSpace: "nowrap"
                    }}
                  >
                    {value}
                  </TableCell>
                );
              })}
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
